import React from 'react';
import { FileDown } from 'lucide-react';
import { downloadBillingCycle837Edi } from '../../services/api';
import { useBillingPdfDownload } from '../../hooks/useBillingPdfDownload';
import {
  BillingDownloadIconButton,
  BillingPdfMenuRow,
} from './BillingPdfMenuRow';

export interface BillingCycle837EdiDownloadButtonProps {
  billingCycleId: string;
  /** When set, render as a full-width labeled menu row instead of an icon-only button. */
  label?: string;
}

export const BillingCycle837EdiDownloadButton: React.FC<
  BillingCycle837EdiDownloadButtonProps
> = ({ billingCycleId, label }) => {
  const { isDownloading, download } = useBillingPdfDownload(
    () =>
      downloadBillingCycle837Edi({
        path: { billing_cycle_id: billingCycleId },
        responseType: 'blob',
      }),
    {
      failureTitle: 'Failed to download EDI file',
      logLabel: '837I EDI',
      fileName: `837i_${billingCycleId}.edi`,
    }
  );
  const handleClick = () => void download();

  if (label) {
    return (
      <BillingPdfMenuRow
        label={label}
        title='Download the 837I electronic claim file (EDI)'
        isDownloading={isDownloading}
        onClick={handleClick}
        icon={FileDown}
      />
    );
  }

  return (
    <BillingDownloadIconButton
      label='Download 837I EDI file'
      isDownloading={isDownloading}
      onClick={handleClick}
      icon={FileDown}
    />
  );
};
